import { render, staticRenderFns } from "./FaceVerifyPopu.vue?vue&type=template&id=c4e37120&scoped=true"
import script from "./FaceVerifyPopu.vue?vue&type=script&lang=js"
export * from "./FaceVerifyPopu.vue?vue&type=script&lang=js"
import style0 from "./FaceVerifyPopu.vue?vue&type=style&index=0&id=c4e37120&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e37120",
  null
  
)

export default component.exports